import $ from "jquery";

function searchJobs() {
  let scroll = $(window).scrollTop();
  let wH = window.innerHeight;
  let footerPos = $("#footer").offset().top;
  if (scroll + wH >= footerPos) {
    let pos = scroll + wH - footerPos;
    $("#job-search-for-sp").css("bottom", pos);
    $(".apply_and_like_button").css("bottom", pos);
  }
}

if (document.URL.match("projects")) {
  $(window).scroll(function () {
    searchJobs();
  });

  $(window).on("load", function () {
    searchJobs();
  });
}
